import {Auth} from "aws-amplify";
import {HEADERS} from "./api";
import checkToken from "./check_token";
import {removeFromStorage} from "../services/LocalStorage";
import {
  KEY_AD_USER,
  KEY_ADMIN_AUTH_TOKEN,
  KEY_PARTNER_SELECTION
} from "./Constants";

async function getAuthHeaders() {
  const token = await checkToken();
  const headers = HEADERS
  if (token) {
    headers.Authorization = token
  }
  return headers;
}

export async function getCurrentSession(){
  return Auth.currentSession()
}

export async function createGetRequest(url) {
  const headers = await getAuthHeaders();
  return new Request(url, {
    method: "GET",
    headers,
    mode: "cors",
    cache: "default",
  });
}

export async function createPostRequest(url, body = "{}") {
  const headers = await getAuthHeaders();
  return new Request(url, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
    mode: "cors",
    cache: "default",
  });
}

export async function createPutRequest(url, body = "{}") {
  const headers = await getAuthHeaders();
  headers.append("content-type", "application/json");
  return new Request(url, {
    method: "PUT",
    headers,
    body,
    mode: "cors",
    cache: "default",
  });
}

export function cleanUpAdminData(){
  removeFromStorage(KEY_ADMIN_AUTH_TOKEN);
  removeFromStorage(KEY_AD_USER);
  removeFromStorage(KEY_PARTNER_SELECTION);
}
